import { CSSProperties, useEffect } from 'react';
import DebugBox from 'components/shareable/DebugBox';
import { styx } from 'modules/Utils';
import useScreen from 'Hooks/useScreen';
import { getIgUserData_api } from 'helpers/FB';
import { useHistory } from 'react-router-dom';
import useCurrentUser from 'Hooks/useCurrentUser';
import useUploadEmailsByCsv from 'Hooks/useUploadEmailsByCsv';
import { searchGeographiesFromFacebook } from 'api/facebookApi';
import useFacebookConnections from 'Hooks/useFacebookConnections';

const TestApiPage = () => {
    const history = useHistory()
    const { isSymphonyAdmin } = useCurrentUser()
    const { cssCalc } = useScreen()

    const {
        loggedInFacebookUser
    } = useFacebookConnections()

    useEffect(() => {
        if (!isSymphonyAdmin) {
            history.push('/')
        }
    }, [])

    const handleSearchFacebookGeographies = async () => {   
        try {
            const res = await searchGeographiesFromFacebook('united states', loggedInFacebookUser?.access_token ?? '')
            console.log(res)
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div
            className="testApiPageComponent"
            style={styx(sty.testApiPageComponent, { height: cssCalc() })}
        >
            <DebugBox
                alwaysShow
                isApi
                dHeight={1000}
                onClick={() => {
                    handleSearchFacebookGeographies()
                }}
            />
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    testApiPageComponent: {
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        backgroundColor: '#333',
    },
    inputSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16
    },
    jsonInput: {
        width: '100%',
        height: 200,
        padding: 12,
        fontFamily: 'monospace',
        fontSize: 14,
        border: '1px solid #ccc',
        borderRadius: 4,
        resize: 'vertical'
    },
    buttonContainer: {
        display: 'flex',
        gap: 12
    },
    responseSection: {
        flex: 1
    },
    responseBox: {
        padding: 16,
        background: '#f5f5f5',
        borderRadius: 4,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
        fontFamily: 'monospace',
        fontSize: 14,
        minHeight: 200
    },
    routeInput: {
        width: '100%',
        height: 40
    }
};

export default TestApiPage;
